var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 3.83337H9.33337C9.06004 3.83337 8.83337 3.60671 8.83337 3.33337C8.83337 3.06004 9.06004 2.83337 9.33337 2.83337H13.3334C13.6067 2.83337 13.8334 3.06004 13.8334 3.33337C13.8334 3.60671 13.6067 3.83337 13.3334 3.83337Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 5.83337H9.33337C9.06004 5.83337 8.83337 5.60671 8.83337 5.33337C8.83337 5.06004 9.06004 4.83337 9.33337 4.83337H11.3334C11.6067 4.83337 11.8334 5.06004 11.8334 5.33337C11.8334 5.60671 11.6067 5.83337 11.3334 5.83337Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66671 14.5C3.90004 14.5 0.833374 11.4334 0.833374 7.66671C0.833374 3.90004 3.90004 0.833374 7.66671 0.833374C7.94004 0.833374 8.16671 1.06004 8.16671 1.33337C8.16671 1.60671 7.94004 1.83337 7.66671 1.83337C4.44671 1.83337 1.83337 4.45337 1.83337 7.66671C1.83337 10.88 4.44671 13.5 7.66671 13.5C10.8867 13.5 13.5 10.88 13.5 7.66671C13.5 7.39337 13.7267 7.16671 14 7.16671C14.2734 7.16671 14.5 7.39337 14.5 7.66671C14.5 11.4334 11.4334 14.5 7.66671 14.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 15.1666C14.54 15.1666 14.4133 15.12 14.3133 15.02L12.98 13.6866C12.7866 13.4933 12.7866 13.1733 12.98 12.98C13.1733 12.7866 13.4933 12.7866 13.6866 12.98L15.02 14.3133C15.2133 14.5066 15.2133 14.8266 15.02 15.02C14.92 15.12 14.7933 15.1666 14.6666 15.1666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2ef3d6526520f743259cae961ae1f8ce.svg";
export { ForwardRef as ReactComponent };